import { Edit, SimpleForm, ReferenceInput, AutocompleteInput, NumberInput, SelectInput } from 'react-admin';

const STATUS_CHOICES = [
  { id: 'pending',  name: 'ממתין' },
  { id: 'paid',     name: 'שולם' },
  { id: 'failed',   name: 'נכשל' },
  { id: 'refunded', name: 'הוחזר' },
];

const CURRENCY_CHOICES = [
  { id: 'ILS', name: '₪ שקל' },
  { id: 'USD', name: '$ דולר' },
];

const METHOD_CHOICES = [
  { id: 'bank_transfer', name: 'העברה בנקאית' },
  { id: 'credit_card',   name: 'כרטיס אשראי' },
  { id: 'paypal',        name: 'PayPal' },
  { id: 'cash',          name: 'מזומן' },
  { id: 'check',         name: "צ'ק" },
];

const PaymentEdit = () => (
  <Edit title="עריכת תשלום">
    <SimpleForm>
      <ReferenceInput source="order_id" reference="orders">
        <AutocompleteInput
          optionText={r => `#${r.id} — ${r.first_name ?? ''} ${r.last_name ?? ''}`.trim()}
          label="הזמנה"
          fullWidth
        />
      </ReferenceInput>
      <NumberInput source="amount" label="סכום" min={0} fullWidth />
      <SelectInput source="currency" label="מטבע" choices={CURRENCY_CHOICES} fullWidth />
      <SelectInput source="payment_method" label="אמצעי תשלום" choices={METHOD_CHOICES} fullWidth />
      <SelectInput source="status" label="סטטוס" choices={STATUS_CHOICES} fullWidth />
    </SimpleForm>
  </Edit>
);

export default PaymentEdit;
